import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/components/Homepage'
import Page from '@/components/Page'
import DiceGame from '@/components/DiceGame'
import FortuneTellerGame from '@/components/FortuneTellerGame'
import RussianRouletteGame from '@/components/RussianRouletteGame'
import CuckooGame from '@/components/CuckooGame'
import BallGame from '@/components/BallGame'
import LotoGame from '@/components/LotoGame'
import RouletteGame from '@/components/RouletteGame'
import CardsGame from '@/components/CardsGame'
import CoinMenu from '@/components/CoinMenu'
import CoinGame from '@/components/CoinGame'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: Homepage
    },
    {
      path: '/page/:slug',
      name: 'page',
      component: Page,
      props: true
    },
    {
      path: '/game/dices',
      name: 'dices',
      component: DiceGame
    },
    {
      path: '/game/russian',
      name: 'russian',
      component: RussianRouletteGame
    },
    {
      path: '/game/fortune-teller',
      name: 'fortune-teller',
      component: FortuneTellerGame
    },
    {
      path: '/game/cuckoo',
      name: 'cuckoo',
      component: CuckooGame
    },
    {
      path: '/game/8ball',
      name: '8ball',
      component: BallGame
    },
    {
      path: '/game/roulette',
      name: 'roulette',
      component: RouletteGame
    },
    {
      path: '/game/bingo',
      name: 'loto',
      component: LotoGame
    },
    {
      path: '/game/cards',
      name: 'cards',
      component: CardsGame
    },
    {
      path: '/game/coin',
      name: 'coin',
      component: CoinMenu
    },
    {
      path: '/game/coin/:coin_type',
      name: 'coin-item',
      props: true,
      component: CoinGame
    }
  ]
})
